import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Banner.css';
import myImg from '../../../image/me/1.png';
import { Link } from 'react-router-dom';
import Typical from 'react-typical';

const Banner = () => {
    return (
        <section id="top" className="banner-container mt-5 pt-5">
            <Container className="mt-5">
                <Row className="d-flex align-items-center mt-3 text-white">
                    <Col
                        data-aos="fade-right"
                        data-aos-offset="400"
                        data-aos-easing="ease-in-sine"
                        xs={12} sm={12} md={8}>
                        <h2 className="fw-bold"><span>JAHID HASAN ANTOR</span></h2>
                        <div className="text-warning">
                            <Typical
                                steps={['A', 1000, 'A MERN Stack Web Developer', 500, 'A Front-End Web Developer', 500, 'A Professional coder', 500]}
                                loop={Infinity}
                                wrapper="h3"
                            />
                        </div>
                        <p className="w-75 mt-4">Passionate about building first-class web applications. I always love to do clean and reusable code.</p>
                        <Link to="https://drive.google.com/file/d/1qM5xYzQ2UTlX3Nu5lcaz9iJddYPMdw-L/view?usp=sharing" target="_blank" download>
                            <button className="primary-button mt-3 mb-4">Download Resume</button>
                        </Link>
                        <a href="#contact">
                            <button className="primary-button">Hire Me</button>
                        </a>
                    </Col>
                    <Col
                        data-aos="fade-left"
                        xs={12} sm={12} md={4}>
                        <img className="img-fluid" src={myImg} alt="" />

                    </Col>
                </Row>

                <Row>
                    <div className="d-flex align-items-center justify-content-center icon py-5">
                        <div className="">
                            <a href="https://www.linkedin.com/in/antor7080/" target="_blank" rel="noreferrer">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="https://twitter.com/antor7080" target="_blank" rel="noreferrer">
                                <i className="fab fa-twitter"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="https://github.com/Antor7080" target="_blank" rel="noreferrer">
                                <i className="fab fa-github"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="https://fb.com/antor15" target="_blank" rel="noreferrer">
                                <i className="fab fa-facebook"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="mailto:antor7080@gmail.com" target="_blank" rel="noreferrer">
                                <i className="fas fa-envelope"></i>
                            </a>
                        </div>
                    </div>

                </Row>

            </Container>

        </section>
    );
};

export default Banner;